import { AlertTypes, CrudTableViewConfig, CrudViewColumnType, HeadingComponentConfig, HeadingType, TextComponentConfig } from '@rappider/rappider-components/utils';

export const FILE_LIST_CONFIG: CrudTableViewConfig = {
  searchable: true,
  sortable: true,
  pageSize: 10,
  showPagination: true,
  nzFrontPagination: true,
  enableRowPointer: true,
  selectAndMark: false,
  searchButtonActive: true,
  searchActive: false,
  selectable: true,
  enableMultipleSelection: true,
  overflowList: {
    items: [],
    minVisibleItems: 10
  },
  columns:
    [
      {
        title: 'File Name',
        type: CrudViewColumnType.Text,
        fieldName: 'name',
        visible: true,
        prefixIconVisible: true,
      },
      {
        title: 'Size',
        type: CrudViewColumnType.Text,
        fieldName: 'size',
        visible: true,
        prefixIconVisible: false
      },
      {
        title: 'Type',
        type: CrudViewColumnType.Text,
        fieldName: 'type',
        visible: true,
        prefixIconVisible: false
      },
      {
        title: 'Last Modified',
        type: CrudViewColumnType.DateTime,
        fieldName: 'lastModifiedDate',
        visible: true,
        prefixIconVisible: false
      }
    ],
  orderable: false,
  listActions: [],
  itemActions: []
};

export const fileListButton = {
  text: 'Ingest',
  type: 'primary',
  tooltipText: 'Please select an item',
  loading: false,
  visible: false
};

export const selectedFileListButton = {
  text: 'Next',
  type: 'primary',
  tooltipText: 'Please select an item',
  loading: false,
  visible: true
};

export const fileListInfoAlertConfig = {
  type: AlertTypes.Info,
  title: <HeadingComponentConfig>{
    content: 'Select a File from the List',
    type: HeadingType.H6
  },
  description: <TextComponentConfig>{
    text: `To select the file, click on it. Then, click the 'Save' button to confirm.`
  },
  closeable: false,
  showIcon: true
};

export const selectedFileListInfoAlertConfig = {
  type: AlertTypes.Info,
  title: <HeadingComponentConfig>{
    content: 'Selected Files',
    type: HeadingType.H6
  },
  description: <TextComponentConfig>{
    text: `Selected files will be listed here.`
  },
  closeable: false,
  showIcon: true
};
